export default __webpack_public_path__ + "static/media/star-fill.baa23a53.svg";